import {
    SHOW_SUCCESSFUL_MESSAGE,
    SHOW_INFO_MESSAGE,
    SHOW_WARNING_MESSAGE,
    SHOW_ERROR_MESSAGE,
    LOGGED_IN_MESSAGE,
    SCROLL_DASHBOARD_TO_TOP,
    UPDATE_SHOW_LOADING,
    USER_LOGOUT
} from './actionConst';

const initialState = {
    message: {
        type: "",
        text: "",
        icon: ""
    },
    dashboard: {
        scrollToTop: null,
        showLoading: false
    },
    showLoggedInMessage: false,
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SHOW_SUCCESSFUL_MESSAGE:
            return {
                ...state,
                message: {
                    type: "success",
                    text: action.payload,
                    icon: "fa fa-check"
                }
            }

        case SHOW_INFO_MESSAGE:
            return {
                ...state,
                message: {
                    type: "info",
                    text: action.payload,
                    icon: "pe-7s-info"
                }
            }

        case SHOW_WARNING_MESSAGE:
            return {
                ...state,
                message: {
                    type: "warning",
                    text: action.payload,
                    icon: "fa fa-warning"
                }
            }

        case SHOW_ERROR_MESSAGE:
            return {
                ...state,
                message: {
                    type: "error",
                    text: action.payload,
                    icon: "fa fa-close"
                }
            }

        case LOGGED_IN_MESSAGE:
            return {
                ...state,
                showLoggedInMessage: action.payload
            }

        case SCROLL_DASHBOARD_TO_TOP: {
            state.dashboard.scrollToTop = action.payload;
            let newDashboard = Object.assign({}, state.dashboard);
            return {
                ...state,
                dashboard: newDashboard
            }
        }

        case UPDATE_SHOW_LOADING: {
            state.dashboard.showLoading = action.payload;
            let newDashboard = Object.assign({}, state.dashboard);
            return {
                ...state,
                dashboard: newDashboard
            }
        }

        default:
            return state;

    }
}


// WEBPACK FOOTER //
// ./src/reducers/application/applicationReducer.js